import { render, staticRenderFns } from "./ProgramsList.vue?vue&type=template&id=c2b346a6&scoped=true"
import script from "./ProgramsList.vue?vue&type=script&lang=js"
export * from "./ProgramsList.vue?vue&type=script&lang=js"
import style0 from "./ProgramsList.vue?vue&type=style&index=0&id=c2b346a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b346a6",
  null
  
)

export default component.exports